module.exports = __webpack_public_path__ + "img/drop_menu.27ed99c6.png";